import { render, staticRenderFns } from "./Behavior.vue?vue&type=template&id=3b6dde72&scoped=true"
import script from "./Behavior.vue?vue&type=script&lang=js"
export * from "./Behavior.vue?vue&type=script&lang=js"
import style0 from "./Behavior.vue?vue&type=style&index=0&id=3b6dde72&prod&scoped=scoped&lang=less"
import style1 from "./Behavior.vue?vue&type=style&index=1&id=3b6dde72&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b6dde72",
  null
  
)

export default component.exports